var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("h1", [_vm._v("My Tickets")]),
      _vm._v(" "),
      _c("Tabs", {
        staticClass: "present-past-events",
        attrs: { items: _vm.tabItems }
      }),
      _vm._v(" "),
      _vm.isFetching
        ? _c("div", { staticClass: "fetching" }, [_c("fx-spinner")], 1)
        : _vm.orders.length
        ? _c(
            "ul",
            { staticClass: "orders" },
            _vm._l(_vm.orders, function(order) {
              return _c(
                "li",
                {
                  key: order.id,
                  staticClass: "orders__item",
                  on: {
                    click: function($event) {
                      _vm.selectedOrder = order
                    }
                  }
                },
                [
                  _c("article", { staticClass: "order" }, [
                    _c("div", {
                      staticClass: "order__thumbnail",
                      style: {
                        backgroundImage:
                          "url(" + _vm.thumbnailImage(order.event) + ")"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-content" }, [
                      _c("header", { staticClass: "order-content__header" }, [
                        _c(
                          "h3",
                          {
                            staticClass:
                              "order-content__heading order-content__date"
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Ordered " +
                                  _vm._s(_vm._f("date")(order.date, "M/D/YY"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "order-content__quantity fx-hidden--full"
                              },
                              [
                                _c("span", { staticClass: "separator" }, [
                                  _vm._v("·")
                                ]),
                                _vm._v(
                                  " Qty: " +
                                    _vm._s(order.ticket.quantity) +
                                    "\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "order-content__status--mobile fx-hidden--full"
                              },
                              [_c("order-status", { attrs: { order: order } })],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "h2",
                          {
                            staticClass:
                              "order-content__heading order-content__event-name"
                          },
                          [_vm._v(_vm._s(order.event.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "h3",
                          {
                            staticClass:
                              "order-content__heading order-content__event-date"
                          },
                          [
                            [
                              _vm.ORDER_STATUS.CREATED,
                              _vm.ORDER_STATUS.PENDING,
                              _vm.ORDER_STATUS.PROCESSED,
                              _vm.ORDER_STATUS.SENT_TO_BUYER
                            ].includes(order.current_status)
                              ? [
                                  order.event.status &&
                                  order.event.status !==
                                    _vm.EVENT_STATUS.SCHEDULED
                                    ? _c("Tag", {
                                        staticClass:
                                          "order-content__event-status-tag",
                                        attrs: {
                                          context: "status",
                                          text: _vm.eventStatusCopy(order)
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  [
                                    _vm.EVENT_STATUS.TBD,
                                    _vm.EVENT_STATUS.POSTPONED
                                  ].includes(order.event.status)
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                    Event updates will be emailed\n                                "
                                        )
                                      ])
                                    : _c("span", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "order-content__event-date-weekday"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("date")(
                                                  order.event.local_date,
                                                  "ddd"
                                                )
                                              ) + ","
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "order-content__event-date-month-day"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("date")(
                                                  order.event.local_date,
                                                  "MMM D"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "order-content__event-date-time"
                                          },
                                          [
                                            _vm._v(
                                              "at " +
                                                _vm._s(
                                                  _vm._f("date")(
                                                    order.event.local_date,
                                                    "h:mma"
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ])
                                ]
                              : _c("span", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "order-content__event-date-weekday"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date")(
                                            order.event.local_date,
                                            "ddd"
                                          )
                                        ) + ","
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "order-content__event-date-month-day"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date")(
                                            order.event.local_date,
                                            "MMM D"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "order-content__event-date-time"
                                    },
                                    [
                                      _vm._v(
                                        "at " +
                                          _vm._s(
                                            _vm._f("date")(
                                              order.event.local_date,
                                              "h:mma"
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "h3",
                          {
                            staticClass:
                              "order-content__heading order-content__event-venue-name"
                          },
                          [
                            _vm._v(
                              _vm._s(order.event.venue.name) +
                                ", " +
                                _vm._s(order.event.venue.city_name) +
                                ", " +
                                _vm._s(order.event.venue.subdivision)
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "order-content__details fx-hidden--small fx-hidden--medium fx-hidden--large"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "order-content__details-quantity-heading"
                            },
                            [_vm._v("Qty")]
                          ),
                          _vm._v(" "),
                          _c(
                            "strong",
                            {
                              staticClass:
                                "order-content__details-quantity-value"
                            },
                            [_vm._v(_vm._s(order.ticket.quantity))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "order-content__status fx-hidden--small fx-hidden--medium fx-hidden--large"
                        },
                        [_c("order-status", { attrs: { order: order } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "icon-chevron-lg-right fx-hidden--full"
                      })
                    ])
                  ])
                ]
              )
            })
          )
        : _c(
            "div",
            [
              _c("NoResults", {
                attrs: {
                  "no-results-copy":
                    "You Have No " +
                    (_vm.isUpcoming ? "Upcoming" : "Past") +
                    " Events",
                  "no-results-secondary-copy":
                    "" +
                    (_vm.isUpcoming
                      ? "When you purchase tickets, you can track all your future events right here."
                      : "After your event has passed, your past orders will live here for your reference."),
                  "redirect-copy": "Choose Your Next Event"
                }
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm.selectedOrder
        ? _c(
            "fxModal",
            {
              staticClass: "order-details",
              attrs: { size: "large", open: true },
              on: {
                close: function($event) {
                  _vm.selectedOrder = null
                }
              }
            },
            [
              _c("OrderCard", {
                attrs: { "is-show-order-date": "", order: _vm.selectedOrder }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }